const keyMap: { [id: string]: string } = {
  id: 'ID',
  sgaccountid: 'SGAccountID',
  vssproviderid: 'VSSProviderID',
  gfspolicysettings: 'GFSPolicySettings'
};

type AnyValueObject = { [key: string]: any };

export class WizardBaseForPlanHelper {
  public static ToPaskalCase(obj: AnyValueObject): AnyValueObject {
    const keys = Object.keys(obj);
    const newPlan = {};

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const lowKey = key.toLowerCase();
      let newKey = key;

      if (keyMap[lowKey]) newKey = keyMap[lowKey];
      else if (lowKey !== 'plan') newKey = key[0].toUpperCase() + key.slice(1);

      newPlan[newKey] = !Array.isArray(obj[key]) ? this.getPaskaleCaseIfObject(obj, key) : this.getPaskaleCaseIfArray(obj, key);
    }

    return newPlan;
  }

  private static getPaskaleCaseIfObject(obj, key: string): AnyValueObject {
    return !(obj[key] === null || obj[key] === undefined) && typeof obj[key] === 'object' ? this.ToPaskalCase(obj[key]) : obj[key];
  }

  private static getPaskaleCaseIfArray(obj, key: string): AnyValueObject {
    return obj[key].map((i) => (typeof i === 'object' ? this.ToPaskalCase(i) : i));
  }
}
